import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import VeteranTypeService from "../../src/Services/VeteranType.service";
import LookupGeneric from "./lookupGeneric";
const VeteranTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<VeteranType[]>' is not assignable to type '(ids: string[]) => Promise<VeteranType[]>'.
        fetchItemsById: (ids) => {
            return VeteranTypeService.getVeteranTypes({ ids }).then(({ data }) => data);
        },
        fetchOptions: (query) => {
            return VeteranTypeService.getVeteranTypes({
                query,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(veteranType) {
            return _jsx("span", { children: veteranType.name });
        },
    });
};
export default VeteranTypeLookup;
